export const TabTitle = (newTitle: string) => {
  return (document.title = newTitle);
};
